import { memo } from 'react';
import { AspectRatio } from 'react-aspect-ratio';
import classNames from 'classnames';

import './SpinLoader.scss';

export type LoaderSize = 's' | 'm' | 'l';

type Props = {
  className?: string;
  size?: LoaderSize;
  paddingClassName?: string;
  centerAlign?: boolean;
};

// based on https://codepen.io/jczimm/pen/vEBpoL
const SpinLoader = (props: Props) => {
  const { className, size = 'l', paddingClassName = '', centerAlign = false } = props;
  return (
    <div
      className={classNames('loader__wrapper', paddingClassName, {
        'CenterAlign Expand': centerAlign,
      })}
    >
      <AspectRatio
        className={classNames('M(a) Bdrs(50%)', className, {
          'W(48px)': size === 'l',
          'W(24px)': size === 'm',
          'W(20px)': size === 's',
        })}
      >
        <svg
          className="loader__svg StretchedBox Expand M(a) Trfo(c) Animn($anim-rotate) Animtf(l) Animic(i) Animdur(2s)"
          viewBox="25 25 50 50"
          preserveAspectRatio="xMidYMid meet"
          role="presentation"
        >
          <circle
            className="loader__circle loader__circle--background Stk($c-bluegray)"
            cx="50"
            cy="50"
            r="22"
            fill="none"
          />
          <circle
            className="loader__circle loader__circle--spinner"
            cx="50"
            cy="50"
            r="22"
            fill="none"
          />
        </svg>
      </AspectRatio>
    </div>
  );
};

export default memo(SpinLoader);
